'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * IT Body Row
 */
ngModule.directive('itRow', function ($compile, $interpolate, scopeUtils) {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: true,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var context = tableCtrl.getContext(),
        config = tableCtrl.getConfig(),
        model = $scope.model;

      // row selection. See itRowSelectionFeature.
      if (config.allowSelection) {
        $el.addClass("it-selectable-row");
        $scope.$watch(function () {
          return tableCtrl.getRowSelection();
        }, function (selection) {
          if (selection === model ||
          // pour les tree
          selection && selection.$node && selection.model === model) {
            $el.addClass("it-selected");
          } else {
            $el.removeClass("it-selected");
          }
        });
      }

      // row construction
      var constructRow = function constructRow() {
        // creating cells
        _.each(context.columns, function (computed) {
          if (!computed.visible) {
            return;
          }
          var cellInjector = computed.cellInjector;
          cellInjector($el, $scope);
        });

        // adding scrollbar cell
        $('<td class="scrollbar"></td>').appendTo($el);

        // force digest of the row scope to interpolate values.
        // needed for height calculation)
        scopeUtils.applyWatchers($scope);
      };

      // perform initialisation
      constructRow();
    },
    controller: function controller($scope) {
      // TODO (?)
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/standard/itRow.js
// module id = 2814
// module chunks = 13